import * as React from "react";
import { motion } from "framer-motion";
import { styled } from "../../theme";
import { ProductGroup } from "db";
import { Box, Heading } from "@chakra-ui/core";
import AccessoryItem from "./AccessoryItem";
export interface Props {
  index: number;
  group: ProductGroup;
}

export default function ProductGroupItem({ index, group }: Props) {
  return (
    <Container variants={variants}>
      <Box>
        <Heading size="md" as="h3" margin={0} pt={3} pb={2} textAlign="center">
          {group.title}
        </Heading>
        <AccessoryList
          variants={{
            open: {
              transition: { staggerChildren: 0.12, delayChildren: 0.2 }
            },
            closed: {
              transition: { staggerChildren: 0.05, staggerDirection: -1 }
            }
          }}
        >
          {group.accessories.map((a, n) => (
            <AccessoryItem key={n} groupIndex={index} index={n} accessory={a} />
          ))}
        </AccessoryList>
      </Box>
    </Container>
  );
}

const Container = motion.custom(styled.li`
  padding: 32px 32px 0 32px;
  margin: 0;
  @media (max-width: 400px) {
    padding: 0;
  }
`);

const AccessoryList = motion.custom(styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`);

const variants = {
  open: {
    x: 0,
    opacity: 1,
    transition: {
      x: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    x: 200,
    opacity: 0,
    transition: {
      x: { stiffness: 1000 }
    }
  }
};
